/**
 * Supplies the conventional labels for the first two outgoing branches of a
 * decision. Existing explicit labels take precedence, so adding a missing
 * branch repairs the other conventional label rather than duplicating one.
 */
export function getDefaultDecisionBranchLabel(
  sourceNodeId: string,
  nodes: Array<{ id: string; type?: string; attrs?: Record<string, unknown> }>,
  edges: Array<{ from?: string; to?: string; attrs?: Record<string, unknown> }>,
): 'Yes' | 'No' | undefined {
  const source = nodes.find((node) => node.id === sourceNodeId);
  const sourceVariant = String(
    source?.attrs?.variant ?? source?.attrs?.shapeType ?? source?.type ?? '',
  ).toLowerCase().replace(/\s+/g, '-');
  if (sourceVariant !== 'decision') return undefined;

  const labels = new Set(
    edges
      .filter((edge) => edge.from === sourceNodeId && !edge.to?.startsWith('__free'))
      .map((edge) => typeof edge.attrs?.label === 'string' ? edge.attrs.label.trim().toLowerCase() : '')
      .filter(Boolean),
  );

  if (!labels.has('yes')) return 'Yes';
  if (!labels.has('no')) return 'No';
  return undefined;
}
